var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotepads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.504,
    height: 41.509,
    viewBox: "0 0 45.504 41.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 45.504,
    height: 41.509,
    fill: "#cea95a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3035",
    "data-name": "Groupe 3035",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3034",
    "data-name": "Groupe 3034",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36710",
    "data-name": "Trac\\xE9 36710",
    d: "M8.18,33.831a.968.968,0,1,1,0-1.937H27.232a.968.968,0,1,1,0,1.937Zm0-6.538a.968.968,0,0,1,0-1.937H27.232a.968.968,0,1,1,0,1.937Zm0-13.073a.968.968,0,0,1,0-1.937h10a.968.968,0,0,1,0,1.937Zm0,6.538a.968.968,0,1,1,0-1.937H27.232a.968.968,0,1,1,0,1.937Zm25.45,9.61c.011-.019.023-.038.032-.055L41.428,16.86,39.8,15.916l-9,15.59,1.628.94Zm1.818.711v7.045a3.39,3.39,0,0,1-3.383,3.385H3.389A3.391,3.391,0,0,1,0,38.124V3.39A3.389,3.389,0,0,1,3.389,0H23.174a.946.946,0,0,1,.581.193l.02.017a.711.711,0,0,1,.087.076l11.3,11.3c.017.017.032.036.049.053h0a.939.939,0,0,1,.231.709V19.6l4.824-8.358a1.76,1.76,0,0,1,2.384-.744l2.046,1.18a1.767,1.767,0,0,1,.541,2.436l-1.63,2.828c-.012.017-.019.036-.031.053l0,0a.412.412,0,0,1-.03.049Zm-1.929-8.142V13.246H25.6A3.389,3.389,0,0,1,22.206,9.86V1.941H3.389A1.454,1.454,0,0,0,1.937,3.394V38.128A1.452,1.452,0,0,0,3.389,39.58H32.066a1.451,1.451,0,0,0,1.453-1.453V34.385l-.007.011-.012.012-.005.007h-.006v.006l-.012.012h0v.005l-.008.008h-.006l-.024.025h-.006l-.008.007h-.005L29.17,38.024a.969.969,0,0,1-1.572-.9l.933-5.422a.971.971,0,0,1,.142-.363ZM25.6,11.309h6.555l-8-8V9.86A1.453,1.453,0,0,0,25.6,11.313Zm17.949,1.92-1.628-.942-1.127,1.959,1.628.94ZM30.224,33.383l-.255,1.483,1.161-.961Z",
    transform: "translate(0 -0.001)",
    fill: "#cea95a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotepads);
export default __webpack_public_path__ + "static/media/iconNotepads.4b36f56c54645064f967e93d260bee5d.svg";
export { ForwardRef as ReactComponent };